import { render } from "./VxCard.vue?vue&type=template&id=6a8f6ea0"
import script from "./VxCard.vue?vue&type=script&lang=js"
export * from "./VxCard.vue?vue&type=script&lang=js"

import "./VxCard.vue?vue&type=style&index=0&id=6a8f6ea0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__